/**
 * Recharge la console à la navigation qui suit un déploiement (AB#888) —
 * voir `lib/version-console.ts`. Monté une fois, dans la coquille.
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import {
  INTERVALLE_VERIFICATION_MS,
  estPerime,
  scriptCourant,
  scriptServi,
} from '../lib/version-console';

export function useConsolePerimee(): void {
  const perimee = useRef(false);
  const { pathname, search } = useLocation();
  const adresse = `${pathname}${search}`;
  const premiere = useRef(adresse);

  useEffect(() => {
    const courant = scriptCourant();
    if (courant === null) return undefined;
    const verifier = (): void => {
      void scriptServi().then((servi) => {
        if (estPerime(courant, servi)) perimee.current = true;
      });
    };
    const auRetour = (): void => {
      if (document.visibilityState === 'visible') verifier();
    };
    const minuterie = window.setInterval(verifier, INTERVALLE_VERIFICATION_MS);
    document.addEventListener('visibilitychange', auRetour);
    return () => {
      window.clearInterval(minuterie);
      document.removeEventListener('visibilitychange', auRetour);
    };
  }, []);

  /* L'adresse a changé (lien, menu, retour arrière) et le code est périmé :
     on recharge CETTE adresse, avec le code servi. */
  useEffect(() => {
    if (adresse === premiere.current) return;
    premiere.current = adresse;
    if (perimee.current) window.location.reload();
  }, [adresse]);
}
